export interface UserAccessFilterSettings {
  search: string;
}

export function defaultUserAccessFilterSettings(): UserAccessFilterSettings {
  return {
    search: ''
  };
}
